<template>
  <div>
    <div>
      <svg
        ref="_svg"
        :width="side + 'px'"
        :height="side + 'px'"
        :viewBox="`0 0 ${side} ${side}`"
        style="overflow:visible;margin-top:20px"
        @click="handleClick"
        @mousedown="handleMouseDown"
        @mouseup="handleMouseUp"
      >
        <g class="gDom" :transform="`rotate(${lastRotateDegree} ${radius} ${radius} )`">
          <path :d="allPathD" stroke="blue" fill="none" :stroke-width="strokeWidth" />
          <path :d="rangedPathD" stroke="red" fill="none" :stroke-width="strokeWidth" />
          <circle :fill="'pink'" :r="10" :cx="cpPathX" :cy="cpPathY" />
        </g>

        <foreignObject
          x="50"
          y="50"
          width="100"
          height="100"
          class="svgDiv"
          :transform="`rotate(${lastRotateDegree} ${radius} ${radius} )`"
        >
          <div class="rs-bar rs-transition rs-first" :style="{transform:rsBarTransform}">
            <div
              class="rs-handle rs-move rs-handle-square"
              style="height: 0px; width: 0px; margin: 0px 0px 0px 9px;"
            />
          </div>
        </foreignObject>
      </svg>
    </div>
    <div>
      <button class="button" @click="rotateSlider(false)">ClockWise</button>
      <button class="button" @click="rotateSlider(true)">CounterClockWise</button>
    </div>
  </div>
</template>

<script>
import TouchPosition from "../modules/touch_position";
import CircleSliderState from "../modules/circle_slider_state.js";
import { Machine, interpret } from "xstate";

export default {
  data() {
    return {
      side: 200,
      radius: 100,
      circleSliderState: null,
      value: 10,
      touchPosition: null,
      angle: 0,
      lastRotateDegree: 0,
      rotateDirectionService: null,
      rotateDirection: "Up",
      mousemoveTicks: 0
    };
  },
  props: {
    circleColor: {
      type: String,
      required: false,
      default: "#334860"
    },
    strokeWidth: {
      type: Number,
      required: false,
      default: 10
    },
    SVMotorDegree: {
      type: Number
    },
    SVMotorUpLimit: {
      type: Number
    },
    SVMotorDownLimit: {
      type: Number
    }
  },
  computed: {
    rsBarTransform() {
      return `rotate(${this.SVMotorDegree}deg)`;
    },

    cpCenter() {
      return this.side / 2;
    },
    cpAngle() {
      return this.angle + Math.PI / 2;
    },
    cpPathX() {
      return this.cpCenter + this.radius * Math.cos(this.cpAngle);
    },
    cpPathY() {
      return this.cpCenter + this.radius * Math.sin(this.cpAngle);
    },
    allPathD() {
      console.log("allPathD");
      let parts = [];
      parts.push("M " + 0);
      parts.push(100);
      parts.push("A");
      parts.push(this.radius);
      parts.push(this.radius);
      parts.push(0);
      parts.push(0);
      parts.push(1);
      parts.push(200);
      parts.push(100);
      return parts.join(" ");
    },
    rangeStartPoint() {
      this.circleSliderState.updateCurrentStepFromValue(this.SVMotorDownLimit);
      let angle = this.circleSliderState.angleValue + Math.PI / 2;
      let valueX = this.cpCenter + this.radius * Math.cos(angle + Math.PI / 2);
      let valueY = this.cpCenter + this.radius * Math.sin(angle + Math.PI / 2);
      return { x: valueX, y: valueY };
    },
    rangeEndPoint() {
      this.circleSliderState.updateCurrentStepFromValue(this.SVMotorUpLimit);
      let angle = this.circleSliderState.angleValue + Math.PI / 2;
      let valueX = this.cpCenter + this.radius * Math.cos(angle + Math.PI / 2);
      let valueY = this.cpCenter + this.radius * Math.sin(angle + Math.PI / 2);

      return { x: valueX, y: valueY };
    },

    rangedPathD() {
      let parts = [];
      parts.push("M " + this.rangeStartPoint.x);
      parts.push(this.rangeStartPoint.y);
      parts.push("A");
      parts.push(this.radius);
      parts.push(this.radius);
      parts.push(0);
      parts.push(0);
      parts.push(1);
      parts.push(this.rangeEndPoint.x);
      parts.push(this.rangeEndPoint.y);
      return parts.join(" ");
    }
  },
  watch: {
    SVMotorDegree: {
      handler: function(n, o) {
        this.updateFromPropValue(n);
      }
    }
  },
  created() {
    const rotateDirectionMachine = Machine({
      initial: "Up",
      states: {
        Up: {
          on: {
            clockWise: "Right",
            counterClockWise: "Left"
          }
        },
        Right: {
          on: {
            clockWise: "Down",
            counterClockWise: "Up"
          }
        },
        Down: {
          on: {
            clockWise: "Left",
            counterClockWise: "Right"
          }
        },
        Left: {
          on: {
            clockWise: "Up",
            counterClockWise: "Down"
          }
        }
      }
    });
    this.rotateDirectionService = interpret(rotateDirectionMachine);
    this.rotateDirectionService.start();

    console.log("created");
    let steps = Array.from(
      {
        length: 360
      },
      (_, i) => i * 1
    );
    // default value 度數
    // 先將 value換成 角度
    this.circleSliderState = new CircleSliderState(
      steps,
      0,
      this.SVMotorDegree + 90
    );
    this.angle = this.circleSliderState.angleValue;
  },
  mounted() {
    this.touchPosition = new TouchPosition(
      this.$refs._svg,
      this.radius,
      this.radius / 2
    );
  },
  methods: {
    handleClick(e) {
      this.touchPosition.setNewPosition(e, this.rotateDirection);

      this.circleSliderState.updateCurrentStepFromAngle(
        this.touchPosition.sliderAngle
      );
      let degree = this.circleSliderState.currentStep - 90;
      // console.log("degree", degree);
      let isTouchWithinAccessableRange = this.touchPosition.isTouchWithinAccessableRange(
        degree,
        this.SVMotorDownLimit,
        this.SVMotorUpLimit
      );
      if (
        this.touchPosition.isTouchWithinSliderRange &&
        isTouchWithinAccessableRange
      ) {
        this.updateAngle(degree);
      }
    },
    handleMouseDown(e) {
      e.preventDefault();
      window.addEventListener("mousemove", this.handleWindowMouseMove);
      window.addEventListener("mouseup", this.handleMouseUp);
    },
    handleMouseUp(e) {
      e.preventDefault();
      window.removeEventListener("mousemove", this.handleWindowMouseMove);
      window.removeEventListener("mouseup", this.handleMouseUp);
      this.mousemoveTicks = 0;
    },
    handleWindowMouseMove(e) {
      e.preventDefault();
      if (this.mousemoveTicks < 5) {
        this.mousemoveTicks++;
        return;
      }
      this.touchPosition.setNewPosition(e, this.rotateDirection);
      this.updateSlider();
    },
    updateSlider() {
      let angle = this.touchPosition.sliderAngle;

      this.circleSliderState.updateCurrentStepFromAngle(angle);
      let degree = this.circleSliderState.currentStep - 90;

      console.log("degree", degree);

      if (degree <= this.SVMotorUpLimit && degree >= this.SVMotorDownLimit) {
        this.updateAngle(degree);
      } else if (degree > this.SVMotorUpLimit) {
        this.updateAngle(this.SVMotorUpLimit);
      } else {
        this.updateAngle(this.SVMotorDownLimit);
      }
    },
    updateAngle(degree) {
      // this.circleSliderState.updateCurrentStepFromAngle(angle);
      // this.angle = this.circleSliderState.angleValue;
      // console.log(" this.angle ", this.angle);
      //這邊要emit通知外部 數值要變動 而不是自主去改圖形
      this.$emit("updateMotorDegree", degree);
    },
    updateFromPropValue(value) {
      this.circleSliderState.updateCurrentStepFromValue(value);
      this.angle = this.circleSliderState.angleValue + Math.PI / 2;
    },
    rotateSlider(isClockWise) {
      let rotateDegree = isClockWise
        ? this.rotateDirectionService.send("clockWise")
        : this.rotateDirectionService.send("counterClockWise");
      this.rotateDirection = this.rotateDirectionService.state.value;

      switch (isClockWise) {
        case true:
          this.lastRotateDegree += 90;
          break;
        case false:
          this.lastRotateDegree -= 90;
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.gDom,
.svgDiv {
  transition: all ease 1s;
}

.svgDiv {
  background-image: url("../../dashboard.png");
  background-size: cover;
  background-position: center center;
  position: relative;
}
.dashboard {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
}
.rs-bar {
  position: absolute;
  top: 50%;
  width: 50%;
  height: 0;
  transform-origin: 100% 50%;
}
.rs-handle {
  background-color: transparent;
  border: 8px solid transparent;
  border-right-color: black;
  margin: -6px 0px 0px 0px !important;
  border-width: 6px 50px 6px 4px;
  &.rs-handle-square {
    border-radius: 0;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>